/**
 * Resolve the user-facing title/body for an announcement based on the
 * active UI locale. Falls back to the canonical (FR) `title`/`body` when
 * the requested locale isn't translated.
 *
 * Posts published before the translations feature only have title/body
 * set · they keep working unchanged.
 */
export function localizedPost(post, locale) {
  if (!post) return { title: '', body: '' };
  const tr = post.translations || {};
  const wanted = tr[locale];
  return {
    title: (wanted?.title?.trim() || post.title || '').trim(),
    body:  (wanted?.body?.trim()  || post.body  || ''),
  };
}
